import styled from "@emotion/styled";

import { fontMerriweather, theme } from "shared/lib/styles";

import NewsletterIcon from "./icon-newsletter.svg";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

// Mobile (Figma 7260:32208): the icon sits top-aligned beside a content column,
// with the button stacked below the text. From tablet up the content column
// turns into a single row so the button moves to the far right of the widget.
export const InnerContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;

  inline-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    align-items: center;
  }
`;

export const StyledNewsletterIcon = styled(NewsletterIcon)`
  flex-shrink: 0;

  inline-size: 48px;
  block-size: 48px;
`;

export const ContentColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  align-items: stretch;

  min-inline-size: 0;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    gap: 16px;
    justify-content: space-between;
    align-items: center;
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const FirstLine = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontMerriweather};
  line-height: 1.4;
  text-align: start;
`;

export const SecondLine = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 1.4;
  text-align: start;
`;

// On mobile the button sits below the text, left-aligned to the text's edge
// (indented past the icon — Figma 7260:32208). On the tablet+ row it just wraps
// the button at the column's trailing edge (space-between handles placement).
export const ButtonContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-start;
`;

export const Button = styled.a`
  display: inline-flex;
  align-items: center;

  padding-block: 10px;
  padding-inline: 16px;

  text-decoration: none;

  border-radius: 2px;

  background-color: #2c4692;

  cursor: pointer;

  transition: background-color 0.2s ease;

  &:hover {
    background-color: #233a7d;
  }
`;

export const SignUpLink = styled.a`
  color: #000000;
  font-weight: 700;
  text-decoration: underline;
`;
